import React from 'react';
import { Card, Descriptions, Skeleton, Typography } from '../../../components';
import { returnAgentUrl, showLastHeartbeat, showHeartbeatStatus } from '../utils';
import { RMSAgents } from './RMSAgents';
import { CloudConfiguration } from './CloudConfiguration';

const { Text } = Typography;

export const ApplianceConfiguration = React.memo(
    ({ appliance, error, cloudAccountType, cloudAccountName, logsUrl }) => {
        if (!appliance) return null;

        let applianceManagementCardTitle;

        if (['rivermeadow_standalone', 'nc2', 'hyperv', 'hpe_vme', 'openshift'].includes(cloudAccountType)) {
            applianceManagementCardTitle = 'Migration Appliance Management';
        } else if (cloudAccountType === 'azure_dr') {
            applianceManagementCardTitle = 'Backup Appliance Management';
        } else {
            applianceManagementCardTitle = 'DR Site RMS Appliance Management';
        }

        return (
            <>
                <Card title="Migration Appliance Configuration" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Status">
                            <Text>{showHeartbeatStatus(appliance)}</Text>
                        </Descriptions.Item>
                        ,
                        {error && (
                            <Descriptions.Item label="Error">
                                <Text>
                                    "This Cloud Account information is not available at the moment. Please check if this
                                    Cloud Account still exists."
                                </Text>
                            </Descriptions.Item>
                        )}
                        <Descriptions.Item label="Last Heartbeat">
                            <Text>{showLastHeartbeat(appliance)}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Cloud Account Name">
                            <Text copyable={!!cloudAccountName}>{cloudAccountName}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Appliance ID">
                            <Text copyable={!!appliance.id}>{appliance.id}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="IP Address">
                            <Text copyable={!!appliance.ip_address}>{appliance.ip_address}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Current Version">
                            <Text>{appliance.appliance_version_num || 'Version not available'}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Creation Version">
                            <Text>{appliance.appliance_original_version_num || 'Version not available'}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Created At">
                            <Text>{new Date(appliance.created_at).toLocaleString(undefined, { hour12: false })}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
                <Card title={applianceManagementCardTitle} size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="URL">
                            {(
                                <a href={appliance.webminURL} target="_blank">
                                    {appliance.webminURL}
                                </a>
                            ) || 'Not available'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Username">
                            <Text>{appliance.webminUserName || 'Not available'}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Password">
                            <Text>{appliance.webminPassword || 'Not available'}</Text>
                        </Descriptions.Item>
                        {logsUrl && <a href={logsUrl}>Logs</a>}
                    </Descriptions>
                </Card>
                {returnAgentUrl(appliance, cloudAccountType) && (
                    <RMSAgents appliance={appliance} cloudAccountType={cloudAccountType} />
                )}
                {appliance.cloud_configuration && (
                    <CloudConfiguration
                        cloudAccountType={cloudAccountType}
                        cloudConfiguration={appliance.cloud_configuration}
                    />
                )}
            </>
        );
    },
);
